<div class="message">
  <img src="assets/images/control-panal/no-invition.png" alt="" />
  <div class="details pt-5">
    <h4>{{ "Invalid Invitation" | translate }}</h4>
  </div>
</div>
